/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

const useFetchFicherosExpediente = (expediente) => {
  const [response, setResponse] = useState()
  const [error, setError] = useState()
  const [loading, setLoading] = useState()
  const [refetch, setRefetch] = useState(false)

  const fetchData = useCallback(() => {
    if (loading || !expediente.numero_expediente) return
    setLoading(true)

    axios
      .get(
        `/expedienteslisa/getDatosFicheros/?tipo=${expediente.tipo_expediente}&numero_expediente=${expediente.numero_expediente}`,
      )
      .then((request_response) => {
        setResponse(request_response.data)
        setError(null)
      })
      .catch((request_error) => setError(request_error))
      .finally(() => setLoading(false))
  }, [expediente])

  useEffect(() => {
    if (!loading) fetchData()
  }, [refetch])

  return { response, error, loading, refetch: () => setRefetch((prev) => !prev) }
}

export default useFetchFicherosExpediente
